import React from "react";

const Address = () => {
  return (
    <section id="address-section" className="address-section py-5">
      <div className="container">
        {/* MAIN HEADING */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h2 className="contact-heading">Contact Us</h2>
            <p className="contact-subtext">
              Get in touch with our global offices for support and inquiries
            </p>
          </div>
        </div>

        <div className="row g-4">
          {/* INDIA */}
          <div className="col-md-4">
            <div className="address-card">
              <div className="address-header">
                <i className="bi bi-geo-alt-fill address-icon"></i>
                <h5>Utran,Surat</h5>
              </div>

              <p>
                <strong>Address:</strong>
                <br />
                Odd Aditya Banglows, Near Kapodra bridge, VIP circle, Utran,
                <br />
                Surat,394105.
              </p>

              <p>
                <strong>Mobile:</strong>{" "}
                <a href="tel:+919879262661">+91 9879262662</a>
              </p>

              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:chintanpatel.1644@gmail.com">
                  chintanpatel.1644@gmail.com
                </a>
              </p>
            </div>
          </div>

          {/* DUBAI */}
          <div className="col-md-4 d-none d-md-flex align-items-center justify-content-center">
            <div
              style={{ height: "350px", display: "flex", alignItems: "center" }}
            >
              <img
                className="img-fluid"
                src="/assets/images/add2.png"
                alt="Image card"
                style={{ maxHeight: "100%" }}
              />
            </div>
          </div>

          {/* USA */}
          <div className="col-md-4">
            <div className="address-card">
              <div className="address-header">
                <i className="bi bi-geo-alt-fill address-icon"></i>
                <h5>Parvat Patiya,Surat</h5>
              </div>

              <p>
                <strong>Address:</strong>
                <br />
                Near Mahavir mobile,behind D R India,Archana road, Parvat
                patiya,
                <br />
                Surat,395010.Near Mahavir mobile,behind D R India,Archana road,
                Parvat patiya,
                <br />
                Surat,395010.
              </p>

              <p>
                <strong>Mobile:</strong>{" "}
                <a href="tel:+919879262661">+91 9879262662</a>
              </p>

              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:chintanpatel.1644@gmail.com">
                  chintanpatel.1644@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Address;
